import {Suspense} from 'react';
import {Outlet, createRoute} from '@tanstack/react-router';
import NotFoundPage from '@/anonymous/views/error/NotFoundPage';
import PublicLayout from '@/public/components/PublicLayout';
import AppLoading from '@/shared/components/ui/AppLoading';
import {Route as rootRoute} from '../__root';

function PublicRoutesLayoutComponent() {
  return (
    <PublicLayout>
      <Suspense fallback={<AppLoading />}>
        <Outlet />
      </Suspense>
    </PublicLayout>
  );
}

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/p',
  component: PublicRoutesLayoutComponent,
  errorComponent: NotFoundPage
});
